<template>
  <div class="returnVisit">
    <el-form :model="returnForm" ref="returnForm" :rules="returnRules" label-width="110px" class="all-form" size="small" style="padding-right: 0">
      <el-row>
        <el-col :span="24">
          <el-form-item :label="Language('是否解决')" prop="isSolved">
            <el-switch v-model="returnForm.isSolved" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="returnForm.isSolved==1">
          <el-form-item :label="Language('满意度评价')">
            <el-switch v-model="isOpenSat" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-show="isOpenSat==1&&returnForm.isSolved==1">
          <el-form-item :label="Language('满意度')">
            <i class="el-icon-star-off cur-p Satisfaction" v-for="(item, index) in detData" :key="item.detId" @click="selectSatisFn(index, item)"></i>
            <span class="mr-10 font-w-b" v-if="selectIndex">{{detData[selectIndex-1].name}}</span>
            <div v-if="detContentList.length" class="mt-10">
              <el-checkbox-group v-model="returnForm.detContent" size="mini">
                <el-checkbox class="mr-10" v-for="(item, index) in detContentList" :key="index" :label="item" border></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="Language('评价')">
            <el-input type="textarea" :rows="4" v-model="returnForm.remark"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="handleSubmitFn">{{Language('提交')}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getSatInfo, saveSatData } from "@/http/orderManagement.js"

export default {
  name: "returnVisit",
  components: {},
  props: ['returnId'],
  data() {
    return{
      vdnId: JSON.parse(LocalStorage.getItem("obj")).vdnId,
      isOpenSat: '1',
      selectIndex: '',
      returnForm: {
        id: '',
        isSolved: '1',
        remark: '',
        detId: '',
        detContent: [],
      },
      detData: [],
      returnRules: {},
      detContentList: [],
    }
  },
  watch:{
    selectIndex(val) {
      if (val) {
        let detContent = this.detData[val-1].detContent
        this.detContentList = detContent?detContent.split('|'):[]
      } else this.detContentList = []
    },
  },  
  created() {
    
  },
  mounted() {
    this.returnForm.id = this.returnId
    this.initData()
  },
  methods: {
    selectSatisFn(index, item) {
      this.selectIndex = Number(index+1)
      this.returnForm.detId = item.detId
      this.returnForm.detContent = []
      this.fillStart(this.selectIndex)
    },
    initData() {
      let self = this
      getSatInfo({
        vdnId: this.vdnId,
        id: this.returnId
      }).then(res => {
        if (res && res.retCode == 1) {
          let resData = res.data.satDet || []
          if (resData.length) {
            resData.map((item, index) => {
              this.detData.push({ detId: item.detId, seq: item.seq, name: item.name, detContent: item.detContent})
            })

            $(function() {
              $('.Satisfaction').each(function() {
                $(this).hover(function() {
                  self.selectIndex = $(this).index()+1
                  self.fillStart(self.selectIndex)
                }, function() {
                  if (self.returnForm.detId) {
                    let obj = self.detData.filter(item => { return  self.returnForm.detId == item.detId })
                    self.selectIndex = obj[0].seq+1
                    self.fillStart(self.selectIndex)
                  } else {
                    self.selectIndex = ''
                    self.fillStart()
                  }
                })
              })
            })
          }
        }
      })
    },
    fillStart(detIndex) {
      if (detIndex) {
        $('.Satisfaction:lt('+detIndex+')').removeClass('el-icon-star-off').addClass('el-icon-star-on')
        $('.Satisfaction:gt('+(detIndex-1)+')').removeClass('el-icon-star-on').addClass('el-icon-star-off')
      } else {
        $('.Satisfaction').removeClass('el-icon-star-on').addClass('el-icon-star-off')
      }
    },
    handleSubmitFn() {
      if (this.returnForm.isSolved==1) {
        if (this.isOpenSat==1 && !this.returnForm.detId) this.$Msg.error('满意度不能为空！')
      } else {
        let subData = {
          ...this.returnForm,
          vdnId: this.vdnId,
          detContent: this.returnForm.detContent.length?this.returnForm.detContent.join(','):''
        }
        saveSatData(subData).then(res => {
          if (res && res.retCode == 1) {
            this.$Msg.success('操作成功');
            this.$emit('closePageView')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .Satisfaction{
    color: #F4AD01;
    vertical-align: middle;
    margin-top: -5px;
  }
  .el-icon-star-on{
    font-size: 32px;
  }
  .el-icon-star-off{
    padding: 0 4px;
    font-size: 24px;
  }
</style>


// WEBPACK FOOTER //
// ReturnVisit.vue?46ddb890